import type { YearCashflow } from '../utils/financialCalculations';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, ReferenceLine, CartesianGrid } from 'recharts';

export default function DscrChart({ cashflows, loanTerm, printMode }: { cashflows: YearCashflow[]; loanTerm: number; printMode?: boolean }) {
  const data = cashflows.filter(cf => cf.year >= 1 && cf.year <= loanTerm).map(cf => ({ year: `J${cf.year}`, dscr: cf.dscr === Infinity ? null : +cf.dscr.toFixed(2) }));
  if (data.length === 0) return null;
  return (
    <div className="bg-white rounded-xl border border-[#D9E2EC] p-4 shadow-sm mb-4">
      <div className="text-xs font-bold text-[#0B1F4A] mb-1">🏦 DSCR — Debt Service Coverage Ratio</div>
      <div className="text-[10px] text-[#8899AA] mb-3">Pre-tax DSCR (EBITDA-based) — Minimumeis banken: 1.2x (rode lijn)</div>
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
          <XAxis dataKey="year" tick={{ fontSize: 10 }} />
          <YAxis tick={{ fontSize: 10 }} domain={[0, 'auto']} />
          <Tooltip formatter={(v: number) => [`${v}x`, 'DSCR']} />
          <ReferenceLine y={1.2} stroke="#EF4444" strokeDasharray="5 5" label={{ value: '1.2x min', fill: '#EF4444', fontSize: 9, position: 'right' }} />
          <ReferenceLine y={1} stroke="#94A3B8" strokeDasharray="3 3" />
          <Line type="monotone" dataKey="dscr" stroke="#0891B2" strokeWidth={2} dot={{ r: 3 }} isAnimationActive={!printMode} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
